import { lightColorPalette } from '@linearb/linui-common';

export const LINB_ISSUE_STATES = {
  CREATED: 'created',
  WIP: 'in-progress',
  DONE: 'done',
  ACC_DONE: 'accumulated_done'
};

export const ISSUE_STATUSES = {
  [LINB_ISSUE_STATES.CREATED]: {
    key: LINB_ISSUE_STATES.CREATED,
    name: 'To Do',
    color: lightColorPalette.lbBrightBlue_100
  },
  [LINB_ISSUE_STATES.WIP]: {
    key: LINB_ISSUE_STATES.WIP,
    name: 'In Progress',
    color: lightColorPalette.lbGreen_100
  },
  [LINB_ISSUE_STATES.DONE]: {
    key: LINB_ISSUE_STATES.DONE,
    name: 'Done',
    color: lightColorPalette.lbGreenDark
  },
  [LINB_ISSUE_STATES.ACC_DONE]: {
    key: LINB_ISSUE_STATES.ACC_DONE,
    name: 'Accumulative Done',
    color: lightColorPalette.lbWhite
  }
};
